// extracted by mini-css-extract-plugin
export var big = "logos-module--big--47bb1";
export var grayscale = "logos-module--grayscale--3550f";
export var horizontal = "logos-module--horizontal--9b5ce";
export var logosSection = "logos-module--logosSection--93fd6";
export var normal = "logos-module--normal--e851e";
export var small = "logos-module--small--71470";
export var square = "logos-module--square--4c7ea";
export var vertical = "logos-module--vertical--a5dda";